import sectionPolicyAccordionBasicCss from '../css-snippets/section-policy-accordion-basic';

const html = `
<style>${sectionPolicyAccordionBasicCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#FFFFFF"
  data-top-padding="true" data-bottom-padding="true"
  style="background-color: rgb(255, 255, 255); color: rgb(0, 0, 0); --text-color: #000000;"
  data-text-color="#000000">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="">
      <div class="wrap-card">
        <div data-attribute="card-accordions" data-show-accordion="true" style="display: block;">
          <div data-attribute="card-accordion" class="wrap-accordion">
            <div data-attribute="accordion-title" class="accordion-title">
              <div data-attribute="accordion-title-text">What Size Should I Order?</div>
              <div class="accordion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-chevron-down-icon lucide-chevron-down">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </div>
            </div>
            <div data-attribute="accordion-content" class="accordion-content">
              <div data-attribute="accordion-text" class="accordion-text">
                <p>Titan Boxer™ follows standard US sizing. We recommend choosing your usual underwear size. If you're
                  between sizes, consider sizing up for a more relaxed fit.You can also check our Size Chart for the
                  most accurate recommendation.</p>
              </div>
            </div>
          </div>

          <div data-attribute="card-accordion" class="wrap-accordion">
            <div data-attribute="accordion-title" class="accordion-title">
              <div data-attribute="accordion-title-text">How Much Leak Protection Do They Provide?</div>
              <div class="accordion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-chevron-down-icon lucide-chevron-down">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </div>
            </div>
            <div data-attribute="accordion-content" class="accordion-content">
              <div data-attribute="accordion-text" class="accordion-text">
                <p><span style="background-color:rgb(255,255,255);color:rgba(0,0,0,0.9);">Titan Boxer™ features a
                    <strong>multi-layer absorbent core</strong> designed to handle <strong>light to moderate
                      leaks</strong> while keeping the outer layer dry.&nbsp;</span></p>
                <p><span style="background-color:rgb(255,255,255);color:rgba(0,0,0,0.9);">The built-in protection
                    helps prevent moisture from reaching your clothes, giving you <strong>extra confidence throughout
                      the day</strong>.</span></p>
              </div>
            </div>
          </div>

          <div data-attribute="card-accordion" class="wrap-accordion">
            <div data-attribute="accordion-title" class="accordion-title">
              <div data-attribute="accordion-title-text">How Long Can I Wear Them?</div>
              <div class="accordion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-chevron-down-icon lucide-chevron-down">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </div>
            </div>
            <div data-attribute="accordion-content" class="accordion-content">
              <div data-attribute="accordion-text" class="accordion-text">
                <p><span style="background-color:rgb(255,255,255);color:rgba(0,0,0,0.9);">Titan Boxer™ is designed for
                    <strong>all-day protection and comfort</strong>. Depending on your level of leakage and daily
                    activity, most customers report <strong>up to 10–12 hours of wear</strong> before needing to
                    change. For heavier leaks, we recommend changing once the absorbent layer feels damp.</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
